import { buildHsocPriceDisplay } from 'pricing-pages-ui-hsoc/components/merch-card-grid/HsocMerchCardPrice';
import { toHsocFeatureItem } from 'pricing-pages-ui-hsoc/components/merch-card-grid/hsocFeatureItem';
import FreeProducts from 'merchandise-lib/constants/FreeProduct';
import { HsocV2PublicPurchaseMotionContainer } from './HsocV2PublicPurchaseMotionContainer';
import { getPresentHsocTierNames } from './hsocPublicTiers';
import { jsx as _jsx } from "react/jsx-runtime";
/*
 * Maps the HSOC V2 productsByTier response into the merch card grid's card
 * props. The CTA cluster is built here (per public context) from the tier's
 * purchaseMotions so purchaseMotion never enters the shared grid package.
 */
export function mapProductsByTierToCards(productsByTier, currencyCode, term, badgesByTierName) {
  if (!productsByTier) {
    return [];
  }
  return getPresentHsocTierNames(productsByTier).map(tierName => {
    const tierOption = productsByTier[tierName];
    const tierApiName = tierName === 'FREE' && !tierOption.productApiName ? FreeProducts.HUBSPOT_FREE : tierOption.productApiName;
    return {
      tierApiName,
      tierName,
      badge: badgesByTierName === null || badgesByTierName === void 0 ? void 0 : badgesByTierName[tierName],
      price: buildHsocPriceDisplay(tierOption.pricing, term, currencyCode, tierName),
      features: tierOption.featuresForTier.map(toHsocFeatureItem),
      ctas: /*#__PURE__*/_jsx(HsocV2PublicPurchaseMotionContainer, {
        tierName: tierName,
        productApiName: tierApiName,
        motions: tierOption.purchaseMotions,
        currencyCode: currencyCode,
        term: term
      })
    };
  });
}